export default {
  title: 'Nahlaste nám když něco nefunguje a získejte tričko',
  questions: [
    { id: 'miesto', type: 'text', label: 'Místo' },
    { id: 'popis', type: 'multiline', label: 'Popis problému' },
  ],
}



// WEBPACK FOOTER //
// ./src/content/devdata/addons/feedback/reportProblem.js